import React, { FC } from "react";

import SecurityTopic from "@/pages/SecurityAwareness/components/SecurityTopic";
import { SecurityTopicEnum } from "@/pages/SecurityAwareness/types";
import {
  eachEmployeeResponsibilityQuiz,
  eachEmployeeResponsibilitySlides,
} from "@/constants/eachEmployeeResponsibility";

const EmployeeResponsibility: FC<{
  isPassed: boolean;
  setTestResults?: React.Dispatch<
    React.SetStateAction<
      Map<string, { score_percent: number; completed_at: string; id: string }>
    >
  >;
}> = ({ isPassed, setTestResults }) => {
  return (
    <SecurityTopic
      slides={eachEmployeeResponsibilitySlides}
      quizName={SecurityTopicEnum.EmployeeResponsibility}
      quizList={eachEmployeeResponsibilityQuiz}
      isPassed={isPassed}
      setTestResults={setTestResults}
    />
  );
};

export default EmployeeResponsibility;
